import { WHATSAPP_URL } from '../data/siteData';
import { PageHero, CTASection } from '../components/UI';

// ── Multi-color illustrated SVG icons per insurance type ──
const InsuranceIcon = ({ type }) => {
  const icons = {
    student: (
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="stGrad" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop stopColor="#10B981"/>
            <stop offset="1" stopColor="#34D399"/>
          </linearGradient>
          <linearGradient id="stGrad2" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop stopColor="#065F46"/>
            <stop offset="1" stopColor="#10B981"/>
          </linearGradient>
        </defs>
        {/* Background circle */}
        <circle cx="28" cy="28" r="28" fill="url(#stGrad)" opacity="0.12"/>
        {/* Shield */}
        <path d="M28 8l16 6v14c0 8-7 14.5-16 17C19 42.5 12 36 12 28V14z" fill="url(#stGrad)" opacity="0.25"/>
        <path d="M28 11l13 4.8v12.8c0 6.5-5.5 11.8-13 13.7-7.5-1.9-13-7.2-13-13.7V15.8z" fill="url(#stGrad2)" opacity="0.2"/>
        {/* Heart + pulse line */}
        <path d="M22 27.5c0-2.5 2-4 3.8-2.5L28 27l2.2-2c1.8-1.5 3.8 0 3.8 2.5 0 1.8-1.5 3.5-6 6-4.5-2.5-6-4.2-6-6z" fill="url(#stGrad)"/>
        {/* Pulse line */}
        <path d="M14 32h4l2-4 3 8 2-6 2 4h5" stroke="#10B981" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    travel: (
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="tvGrad" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3B82F6"/>
            <stop offset="1" stopColor="#06B6D4"/>
          </linearGradient>
        </defs>
        <circle cx="28" cy="28" r="28" fill="url(#tvGrad)" opacity="0.12"/>
        {/* Globe */}
        <circle cx="28" cy="25" r="13" stroke="#3B82F6" strokeWidth="1.8" fill="#EFF6FF" opacity="0.6"/>
        <ellipse cx="28" cy="25" rx="6" ry="13" stroke="#3B82F6" strokeWidth="1.5"/>
        <line x1="15" y1="25" x2="41" y2="25" stroke="#3B82F6" strokeWidth="1.5"/>
        {/* Plane */}
        <path d="M36 18c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3l-2.6.6-3.9 5.2h-2l1.3-5.2-2.6.7-1 1.3H24l.7-2.6-.7-2.6h.7l1 1.3 2.6.7 1.3-5.2h2l3.9 5.2 2.6.6z" fill="#3B82F6"/>
        {/* Umbrella for protection */}
        <path d="M22 38c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="#06B6D4" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
        <path d="M28 32v8M26 40h4" stroke="#06B6D4" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    ),
    international: (
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="intGrad" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop stopColor="#8B5CF6"/>
            <stop offset="1" stopColor="#C4B5FD"/>
          </linearGradient>
          <linearGradient id="intGrad2" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop stopColor="#7C3AED"/>
            <stop offset="1" stopColor="#8B5CF6"/>
          </linearGradient>
        </defs>
        <circle cx="28" cy="28" r="28" fill="url(#intGrad)" opacity="0.12"/>
        {/* Family figures */}
        {/* Adult 1 */}
        <circle cx="18" cy="18" r="4" fill="url(#intGrad2)" opacity="0.8"/>
        <path d="M11 34c0-3.9 3.1-7 7-7s7 3.1 7 7" fill="url(#intGrad2)" opacity="0.6"/>
        {/* Adult 2 */}
        <circle cx="38" cy="18" r="4" fill="url(#intGrad2)" opacity="0.8"/>
        <path d="M31 34c0-3.9 3.1-7 7-7s7 3.1 7 7" fill="url(#intGrad2)" opacity="0.6"/>
        {/* Child */}
        <circle cx="28" cy="22" r="3" fill="#8B5CF6"/>
        <path d="M22 36c0-3.3 2.7-6 6-6s6 2.7 6 6" fill="#8B5CF6" opacity="0.7"/>
        {/* Shield umbrella over family */}
        <path d="M13 15c0-8.3 6.7-15 15-15s15 6.7 15 15" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.3"/>
        {/* Check badges */}
        <circle cx="42" cy="40" r="6" fill="url(#intGrad2)"/>
        <path d="M39.5 40l2 2 3-3" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    work: (
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="wkGrad" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F59E0B"/>
            <stop offset="1" stopColor="#FBBF24"/>
          </linearGradient>
          <linearGradient id="wkGrad2" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop stopColor="#D97706"/>
            <stop offset="1" stopColor="#F59E0B"/>
          </linearGradient>
        </defs>
        <circle cx="28" cy="28" r="28" fill="url(#wkGrad)" opacity="0.12"/>
        {/* Briefcase */}
        <rect x="12" y="22" width="32" height="22" rx="3" fill="url(#wkGrad)" opacity="0.25"/>
        <rect x="13" y="23" width="30" height="20" rx="2.5" fill="url(#wkGrad2)" opacity="0.2"/>
        {/* Handle */}
        <path d="M21 22v-3a3 3 0 013-3h8a3 3 0 013 3v3" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" fill="none"/>
        {/* Center latch */}
        <rect x="25" y="30" width="6" height="4" rx="1" fill="#F59E0B" opacity="0.8"/>
        <line x1="12" y1="33" x2="44" y2="33" stroke="#F59E0B" strokeWidth="1.5" opacity="0.5"/>
        {/* Shield badge */}
        <path d="M38 38l6 2v5c0 2.5-2.2 4.5-6 5.3-3.8-.8-6-2.8-6-5.3v-5z" fill="url(#wkGrad2)"/>
        <path d="M35.5 42.5l2 2 3-3" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  };
  return icons[type] || null;
};

const insuranceData = [
  {
    key: 'student',
    name: 'Student Health Insurance',
    accent: '#10B981',
    accentLight: 'rgba(16,185,129,0.1)',
    gradFrom: 'from-emerald-500',
    gradTo: 'to-green-400',
    badge: 'Visa Mandatory',
    badgeBg: 'bg-emerald-50 text-emerald-700',
    desc: 'Mandatory for most student visas. Covers medical treatment, hospitalisation, emergencies, and prescriptions abroad.',
    features: [
      'Medical & hospital cover',
      'Emergency evacuation',
      'Prescription drugs',
      'Mental health coverage',
      'Dental & optical (optional)',
    ],
  },
  {
    key: 'travel',
    name: 'Travel & Visit Insurance',
    accent: '#3B82F6',
    accentLight: 'rgba(59,130,246,0.1)',
    gradFrom: 'from-blue-500',
    gradTo: 'to-cyan-400',
    badge: 'Schengen Required',
    badgeBg: 'bg-blue-50 text-blue-700',
    desc: 'Required for Schengen and many other visit visas. Covers medical emergencies, trip cancellation, lost luggage, and delays.',
    features: [
      'Medical emergency cover (€30,000 min for Schengen)',
      'Trip cancellation & delay',
      'Lost or stolen baggage',
      'Repatriation cover',
      '24/7 emergency assistance',
    ],
  },
  {
    key: 'international',
    name: 'International Health Insurance',
    accent: '#8B5CF6',
    accentLight: 'rgba(139,92,246,0.1)',
    gradFrom: 'from-violet-500',
    gradTo: 'to-purple-400',
    badge: 'Family Plans',
    badgeBg: 'bg-violet-50 text-violet-700',
    desc: 'For families and professionals relocating abroad long-term. Comprehensive health cover across multiple countries.',
    features: [
      'Inpatient & outpatient cover',
      'Maternity & newborn',
      'Pre-existing conditions',
      'Multi-country coverage',
      'Family plans available',
    ],
  },
  {
    key: 'work',
    name: 'Work Abroad Insurance',
    accent: '#F59E0B',
    accentLight: 'rgba(245,158,11,0.1)',
    gradFrom: 'from-amber-500',
    gradTo: 'to-yellow-400',
    badge: 'Skilled Migrants',
    badgeBg: 'bg-amber-50 text-amber-700',
    desc: 'For skilled migrants and workers abroad. Covers income protection, public liability, and employer liability requirements.',
    features: [
      'Income protection',
      'Public & employer liability',
      'Personal accident cover',
      'Legal expenses',
      'Employer requirement compliance',
    ],
  },
];

const countryRequirements = [
  { flag: '🇪🇺', region: 'Schengen / Europe', req: 'Minimum €30,000 medical cover required before visa is processed', color: '#3B82F6' },
  { flag: '🇦🇺', region: 'Australia',          req: 'OSHC (Overseas Student Health Cover) mandatory for all student visa holders', color: '#10B981' },
  { flag: '🇬🇧', region: 'United Kingdom',      req: 'IHS (Immigration Health Surcharge) required + supplementary cover recommended', color: '#8B5CF6' },
  { flag: '🇨🇦', region: 'Canada',              req: 'Provincial health cover required — varies by province. Gap cover needed for waiting periods', color: '#F59E0B' },
];

export default function Insurance({ setPage }) {
  return (
    <div>
      <PageHero
        breadcrumb="Insurance"
        title="International Insurance"
        subtitle="Mandatory for most visas — and essential for your peace of mind abroad. We arrange student health, travel, and international insurance for all destinations."
      />

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          {/* ── HEADER ── */}
          <div className="text-center mb-14">
            <span className="section-tag">Coverage Types</span>
            <h2 className="font-display text-4xl sm:text-5xl text-navy font-semibold mt-1 mb-3">
              Find the Right Cover for Your Visa
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto leading-relaxed">
              We match you to the right insurance type, ensure it meets your exact visa requirements, and handle all activation and documentation.
            </p>
          </div>

          {/* ── INSURANCE CARDS ── */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-16">
            {insuranceData.map(ins => (
              <div
                key={ins.key}
                className="bg-white border border-gray-100 rounded-2xl overflow-hidden hover:shadow-[0_20px_60px_rgba(11,31,58,0.1)] hover:-translate-y-1 transition-all duration-300 group relative"
              >
                {/* Gradient top bar */}
                <div className={`h-1 bg-gradient-to-r ${ins.gradFrom} ${ins.gradTo}`}/>

                <div className="p-7">
                  {/* Icon + badge row */}
                  <div className="flex items-start justify-between mb-5">
                    <div className="w-14 h-14 drop-shadow-md">
                      <InsuranceIcon type={ins.key} />
                    </div>
                    <span className={`text-[0.65rem] font-bold tracking-wide uppercase px-3 py-1.5 rounded-full ${ins.badgeBg}`}>
                      {ins.badge}
                    </span>
                  </div>

                  <h4 className="font-body font-bold text-navy text-lg mb-2">{ins.name}</h4>
                  <p className="text-gray-500 text-sm leading-relaxed mb-5">{ins.desc}</p>

                  {/* Features */}
                  <div className="flex flex-col gap-2 mb-6">
                    {ins.features.map(f => (
                      <div key={f} className="flex items-start gap-2.5 text-xs text-gray-500">
                        <svg className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" viewBox="0 0 14 14" fill="none" style={{ color: ins.accent }}>
                          <circle cx="7" cy="7" r="6" fill="currentColor" opacity="0.12"/>
                          <path d="M4.5 7l2 2 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {f}
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href={`${WHATSAPP_URL}?text=Hi, I need information about ${encodeURIComponent(ins.name)}`}
                    target="_blank" rel="noreferrer"
                    className="inline-flex items-center gap-2 text-sm font-bold transition-all duration-200 hover:gap-3"
                    style={{ color: ins.accent }}
                  >
                    Get a Quote
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                    </svg>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* ── WHY IT MATTERS ── */}
          <div className="bg-navy rounded-3xl p-10 text-white">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
              <div>
                <div className="flex items-center gap-3 mb-5">
                  {/* Warning/alert icon */}
                  <div className="w-12 h-12 rounded-xl flex-shrink-0 overflow-hidden">
                    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
                      <circle cx="24" cy="24" r="24" fill="#EF4444" opacity="0.2"/>
                      <path d="M24 10l18 32H6L24 10z" fill="#EF4444" opacity="0.3"/>
                      <path d="M24 22v7" stroke="#FCA5A5" strokeWidth="2.5" strokeLinecap="round"/>
                      <circle cx="24" cy="33" r="1.5" fill="#FCA5A5"/>
                    </svg>
                  </div>
                  <h2 className="font-display text-2xl font-semibold">Insurance Is Not Optional. It's a Visa Requirement.</h2>
                </div>
                <p className="text-white/55 text-sm leading-relaxed">Most student visas and all Schengen applications require proof of valid insurance before your application is even processed. Getting refused because of missing or invalid insurance documentation is entirely avoidable — and we make sure it never happens.</p>
              </div>

              <div className="flex flex-col gap-4">
                {countryRequirements.map(({ flag, region, req, color }) => (
                  <div key={region} className="flex gap-4 items-start bg-white/5 border border-white/8 rounded-xl p-4 hover:border-white/15 transition-all">
                    <span className="text-2xl flex-shrink-0">{flag}</span>
                    <div>
                      <div className="font-body font-bold text-sm mb-1" style={{ color }}>
                        {region}
                      </div>
                      <span className="text-white/55 text-xs leading-relaxed">{req}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTASection
        title="Need Help with Insurance?"
        subtitle="Tell us your destination and visa type — we'll arrange the right cover, activate it, and provide embassy-compliant documentation."
        setPage={setPage}
      />
    </div>
  );
}
